<template>
  <div class="dataTablesWrapper">
    <div class="hvh-flex space-between align-center mb-3" v-if="hasSearchBlock">
      <div alwaysOn v-if="hasSearchBlock">
        <v-text-field v-model="localValue.searchText" label="Search" outline hide-details prepend-inner-icon="mdi-magnify" @input="debounceSearch" v-if="!propToBool(noSearch)" />
      </div>
      <slot name="menu" />
    </div>
    <div class="position-relative overflow-x">
      <div :class="tableWrapClass">
        <div class="position-relative">
          <v-progress-linear class="progress ma-auto disabled" :indeterminate="true" :height="3" v-if="isLoading" />
          <table class="v-datatable v-table theme--light" :class="tableClass" ref="table">
            <thead ref="head">
              <slot name="head" />
            </thead>
            <tbody>
              <template v-if="length">
                <slot name="body" :item="item" :index="((localValue.page || 1) - 1) * (localValue.perPage || 15) + data.indexOf(item)" v-for="item in data" />
              </template>
              <template v-else>
                <tr>
                  <td :colspan="colspanLength">
                    <slot name="emptySearchText" v-if="localValue.searchText">No entries were found.</slot>
                    <slot name="emptyTableText" v-else>No entries were found.</slot>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          <Loader v-if="isLoading" />
        </div>
      </div>
      <div class="v-datatable v-table theme--light hvh-flex space-between" v-if="!propToBool(noFooter) && hasPagination">
        <div>
          <slot name="footerLeft" />
        </div>
        <Pagination :value="localValue.page" :total="length" :perPage="localValue.perPage || 15" @input="emitState({ page: $event })" v-if="hasPagination" />
      </div>
      <slot name="after" />
    </div>
  </div>
</template>

<script>
import { Debouncer, getAllChildrens, propToBool } from '../../../libraries/common';
import Loader from '../loader/Loader.vue';
import Pagination from './Pagination.vue';

export default {
  name: 'hvh-data-table-async',
  components: { Pagination, Loader },
  props: ['data', 'value', 'tableWrapClass', 'tableClass', 'noSearch', 'noFooter', 'length', 'searchPlaceholder', 'isLoading'],
  data(self) {
    return {
      localValue: { ...self.value },
      searchDebounce: new Debouncer(500),
      colspanLength: 0,
      $tds: [],
    };
  },
  computed: {
    isDataTable() {
      return true;
    },
    hasPagination() {
      return this.length > (this.localValue.perPage || 15);
    },
    hasSearchBlock() {
      return !propToBool(this.noSearch) || this.$slots.menu?.any();
    },
  },
  methods: {
    emitState(obj) {
      if (!this.$listeners['input'])
        this.localValue = { ...this.localValue, ...obj };
      else
        this.$emit('input', { ...this.localValue, ...obj });
    },
    getHeadChildren() {
      var els = getAllChildrens(this.$refs.head).filter(f => f.tagName === 'TH');
      return els.map(f => this.$children.find(g => g.$el === f)).filter(f => f);
    },
    debounceSearch(searchText) {
      this.searchDebounce.clear().push(() => this.emitState({ page: 1, searchText }));
    },
    calculateColspanLength() {
      if (this.$refs.head) {
        return this.colspanLength = Array.from(this.$refs.head.childNodes)
          .max(f => f.childNodes.length);
      }
      return 0;
    },
    propToBool,
  },
  watch: {
    value() {
      this.localValue = { ...this.value };
    },
  },
  updated() {
    var colspanLength = this.calculateColspanLength();
    if (this.colspanLength !== colspanLength)
      this.colspanLength = colspanLength;
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window.thisDataTableAsync = this;
    this.colspanLength = this.calculateColspanLength();
  },
};
</script>
